(function () {
  Flint.file('mframework/views/videoChooser.js', function (require) {
    Flint.staticStyles('VideoChooser', {
      '$actionRow': '#_flintapp actionRow.VideoChooser, #_flintapp .VideoChooser.actionRow, #_flintapp .ViewVideoChooser.actionRow, #_flintapp .VideoChooser > .actionRow'
    }, {
      '$actionRow': {
        flexDirection: 'row',

        justifyContent: 'space-around'
      }
    });
    Flint.view('VideoChooser', function (view, on, $) {
      var pro = initPro(view, {
        initialVideoKey: M.defaultAtom(null),
        editable: M.defaultAtom(true),
        circle: M.defaultAtom(false),
        width: M.defaultAtom(300),
        height: M.defaultAtom(300),
        videoStyle: M.mapAtom({}),
        noVideoStyle: M.mapAtom({}),
        zoomable: M.defaultAtom(false),

        // If we get children, the children are the viewer when we have a videoKey.
        // Otherwise we'll provide our own viewer.
        children: atom()
      });

      var videoKey = atom(pro.initialVideoKey.get());

      var workingVideoKey = atom(null);

      var editing = atom(false);

      var previewVideoKey = derivation(function () {
        return editing.get() ? workingVideoKey.get() : videoKey.get();
      });

      videoKey.react(function (videoKey) {
        if (pro.editable.get() && !videoKey) {
          editing.set(true);
        }
      });

      editing.react(function (editing) {
        if (editing) {
          workingVideoKey.set(videoKey.get());
        }
      });

      var select = function select() {
        videoKey.set(workingVideoKey.get());

        if (view.props.onSelect) {
          view.props.onSelect({ videoKey: videoKey.get() });
        }

        editing.set(false);
      };

      var wistiaId = workingVideoKey.lens({
        get: function get(videoKey) {
          return videoKey ? videoKey.split('/')[2] : null;
        },
        set: function set(videoKey, wistiaId) {
          return wistiaId ? 'videos/wistia/' + wistiaId : null;
        }
      });view.render(function () {
        return Flint.iff(editing.get()) && view.el(
          ['editSection', 1],
          { if: editing.get() },
          view.el(['TextBox', 1], { className: 'inpVideoKey',
            placeholder: 'Wistia video hash-id',
            value: wistiaId.or(''),
            onChange: function (e) {
              return wistiaId.set(e.value.trim() || null);
            },
            onEnter: select,
            inpStyle: {
              width: pro.width.get()
            }
          })
        );
      });view.render(function () {
        return Flint.iff(!videoKey.get()) && view.el(['noVideo', 1], { if: !videoKey.get(),
          style: pro.noVideoStyle.get()
        });
      });view.render(function () {
        return Flint.iff(!editing.get() && videoKey.get() && !pro.children.get() || editing.get() && previewVideoKey.get()) && view.el(['Video', 1], { if: !editing.get() && videoKey.get() && !pro.children.get() || editing.get() && previewVideoKey.get(),
          videoKey: previewVideoKey.get(),
          width: pro.width.get(),
          height: pro.height.get(),
          circle: pro.circle.get(),
          videoStyle: pro.videoStyle.get()
        });
      });view.render(function () {
        return Flint.iff(!editing.get() && videoKey.get() && pro.children.get()) && view.el(
          ['customViewMode', 1],
          { if: !editing.get() && videoKey.get() && pro.children.get() },
          pro.children.get()
        );
      });view.render(function () {
        return Flint.iff(pro.editable.get() && !editing.get()) && view.el(
          ['actionRow', 1],
          { if: pro.editable.get() && !editing.get() },
          view.el(['EditLink', 1], { onClick: function () {
              return editing.set(true);
            } }),
          Flint.iff(videoKey.get()) && view.el(['DeleteButton', 1], { if: videoKey.get(), onClick: function () {
              workingVideoKey.set(null);
              select();
            } })
        );
      });

      '26e8dd5d';

      $["actionRow"] = function (_, _index) {
        return { width: pro.width.get() };
      };
    });
  })
})();
//# sourceMappingURL=videoChooser.js.map
